import Login from './Login'

const authResource = {
  login: Login,
}

export default authResource
